import { COMPARE_FLIGHT_UTM_CAMPAIGN_PREFIX, COMPARE_FLIGHT_UTM_MEDIUMS } from '../constants';

/**
 * Пришёл ли пользователь по ссылке флайта сравнения ЖК:
 * utm_campaign начинается с b2c_nov и utm_medium равен cpm или cpv.
 * Читается только на клиенте: SSR-стейт содержит канонический queryString без UTM-меток.
 */
export function hasCompareFlightUtm(): boolean {
  /* istanbul ignore next */
  if (typeof window === 'undefined') {
    return false;
  }

  const searchParams = new URLSearchParams(window.location.search);
  const campaign = searchParams.get('utm_campaign') ?? '';
  const medium = searchParams.get('utm_medium') ?? '';

  return campaign.startsWith(COMPARE_FLIGHT_UTM_CAMPAIGN_PREFIX) && COMPARE_FLIGHT_UTM_MEDIUMS.includes(medium);
}
